export type Builder<T> = { [k in keyof T]: (arg: T[k]) => Builder<T> } & { build(): T } & { setAtType(arg: string): Builder<T> };

export class BuilderFactory {

  // you can pass a type to be created + constructor parameters to use
  // however, the constructor parameters are not type safe and must be in correct order
  // use with care <3
  static createBuilder<T>(type?: (new (...a) => T), ...args): Builder<T> {
    let obj;
    // type must be a constructable type, not an interface
    // if you use the factory to build an object implementing a certain interface, do not provide the type parameter
    if (type) {
      obj = new type(...args);
    } else {
      obj = {} as T;
    }

    const builder = new Proxy({}, {
      get(target, prop) {
        // if calling build()
        if (prop === 'build') {
          return () => obj;
        }
        if (prop === 'setAtType') {
          return (x: string): any => {
            obj['@type'] = x;
            return builder;
          };
        }
        // else if calling any other field in T
        return (x: any): any => {
          (obj[prop] = x);
          return builder;
        };
      }
    });

    return builder as Builder<T>;
  }
}
